<template>
    <form
        class="form-container"
        :class="labelPosition ? 'form-label-' + labelPosition : ''"
    >
        <slot></slot>
    </form>
</template>

<script>
    export default {
        name: 'FormBox',
        props: {
            labelPosition: String
        }
    };
</script>